import React from 'react'; 
import { browserHistory } from 'react-router';
import NavigationHeader from '../components/navigationHeader';
import LoadRealTimeCompoent from "./loadrealtimecompoents"
import RcTooltip from 'rc-tooltip';
import {getLatestEnvironmentList,addUserTracking,deleteUserTracking} from '../utils/realtimeEventHandle'
import { v4 as uuidv4 } from 'uuid'; // For generating unique IDs
import {getTeamId,getUserId} from '../utils/common_utils'
import NoDataComponent from "./noDataComponent";
import Load from '../components/loadAction';
import {IS_NONE_CHECK} from "../utils/constant";
import DrxReportFullScreen from "../monitor/components/dqReportFullScreen"

// import AiAssistant from '../components/ai-assistant';
// import { useLocation } from "react-router-dom";
import {getFeatureAccess} from "../utils/common_utils"


export default class RealTime extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedTab:"DQ",
      // selectedTab:"PIPELINE",
      selectedEnvName:"",
      selectedEnvId:"",
      envList:[],
      browserSessionId: null,
      browserTabId: null,
      teamId:getTeamId(),
      userId:getUserId(),
      errorOccurred: false,
      noData:true,
      loader : true,
      isDrxReportFullscreenMode:false,
    }
    this.handleTabSelection = this.handleTabSelection.bind(this);
    this.callbackEnvironemnt = this.callbackEnvironemnt.bind(this);
    this.closedrxReportfullscreen = this.closedrxReportfullscreen.bind(this);
    this.drxReport = this.drxReport.bind(this);

    // const { location } = this.props;
    // const { data } = location.state || {};
    // alert(JSON.stringify(data));

  }

  getLatestEnvironmentResponse(){
    let requestParams = {
        // "tab_type": 1, // DQ Tab
        "tenant_id":this.state.teamId, // Team Id
        "user_id":this.state.userId
    }
    if(this.state.selectedTab === "PIPELINE"){
      requestParams["tab_type"] = 3
    }
    else if(this.state.selectedTab === "DQ"){
            requestParams["tab_type"] = 1

    }
      else if(this.state.selectedTab === "VERTICAL"){
            requestParams["tab_type"] = 1

    }
    return getLatestEnvironmentList(requestParams);
  }
  getPipelineLatestEnvironmentResponse(){
    let requestParams = {
        "tab_type": 3, // DQ Tab
        "tenant_id":this.state.teamId, // Team Id
        "user_id":this.state.userId
    }
    return getLatestEnvironmentList(requestParams);
  }

  async componentDidMount() {
       document.body.style.overflow = "hidden";
    // Handle session ID - persists until browser is closed
        let existingSessionId = sessionStorage.getItem("browserSessionId");
        let sessionId;
        sessionId = existingSessionId
        if (!existingSessionId) {
          const newSessionId = uuidv4();
          sessionId = newSessionId
          sessionStorage.setItem("browserSessionId", newSessionId);
          this.setState({ browserSessionId: newSessionId });
        } else {
          this.setState({ browserSessionId: existingSessionId });
        }

        // Handle tab ID - unique for each browser tab
        const newTabId = uuidv4();
        localStorage.setItem("browserTabId", newTabId);
        this.setState({ "browserTabId": newTabId });

        // alert("Tab Id"+newTabId)
        // alert("sessionId"+sessionId)

        let requestParams = {
          "browser_tab_id": newTabId, // DQ Tab
          "session_id":sessionId, // Team Id
          "tenant_id":this.state.teamId, // Team Id
          "user_id":this.state.userId,
          "menu_type": "monitor"
        }
        addUserTracking(requestParams)
        // Cleanup when tab is closed
        window.addEventListener("beforeunload", this.handleTabClose);
    //  if (this.state.selectedTab !== "VERTICAL")   {
      try {
          let watchListResponse = await this.getLatestEnvironmentResponse();  
          if (!watchListResponse) {
            this.setState({ errorOccurred: true });
          } else if (watchListResponse.response.env_details) {
            let env = watchListResponse.response.env_details
          let latestEnvId = watchListResponse.response.latest_env_id;

            let selectedEnv = env.find(e => e.env_id === latestEnvId);
            let noData = false;

            if (latestEnvId === null) {
              selectedEnv = env[0];
              noData = true;
            }

                if (selectedEnv && selectedEnv.is_integrations === false) {
                  noData = true;
                }

                if (selectedEnv) {
                            this.setState({ 
                selectedEnvId: selectedEnv.env_id,
                selectedEnvName: selectedEnv.env_name,
                envList: env,
                noData:noData,                
                loader: false,
              });
            }
            else {
              this.setState({ noData: noData, loader: false });
            }
          }
        } catch (error) {
          console.error("Error fetching environment data:", error);      
          this.setState({ errorOccurred: true });
        }
      // }
      // else if (selectedEnv && !selectedEnv.is_integrations) {
      //     throw new Error("Environment has is_integrations set to false.");
      // } else {
      //     throw new Error("Environment with the specified latest_env_id not found.");
      // }
      }
  

  componentWillUnmount() {
   // alert("call post clear")
    let requestParams = {
      "browser_tab_id": this.state.browserTabId, // DQ Tab
      "session_id":this.state.browserSessionId, // Team Id
      "tenant_id":this.state.teamId, // Team Id
      "user_id":this.state.userId
    }
    deleteUserTracking(requestParams)
    window.removeEventListener("beforeunload", this.handleTabClose);
    document.body.style.overflow = "auto";

  }

  handleTabClose = () => {
    localStorage.removeItem("browser_tab_id");
  };

  drxReport(){
        document.body.classList.add("overflow-hidden");
        this.setState({
            isDrxReportFullscreenMode:true,
            DrxReportFullScreenClassKey:"show",
            DrxReportName:"testing"
        });
    }

 

    closedrxReportfullscreen(){
        document.body.classList.remove("overflow-hidden");
        this.setState({isDrxReportFullscreenMode:false,DrxReportFullScreenClassKey:""});
    }

async handleTabSelection(e) {
  sessionStorage.removeItem("selectedWatchlist");
  sessionStorage.removeItem("selectedPipelineWatchlist");
  const selectedTabName = e.currentTarget.getAttribute("data-name");

  if (selectedTabName === "MODEL") {
    browserHistory.push("/monitor/ml");
    return;
  }

  this.setState({ loader: true, noData: true })
  // Update selected tab first
  this.setState({ selectedTab: selectedTabName}, async () => {
        //  if (this.state.selectedTab !== "VERTICAL")   {
      try {
        let watchListResponse = await this.getLatestEnvironmentResponse();  

        if (!watchListResponse) {
          this.setState({ errorOccurred: true });
        } else if (watchListResponse.response.env_details) {
          let env = watchListResponse.response.env_details;
          let latestEnvId = watchListResponse.response.latest_env_id;

          let selectedEnv = env.find(e => e.env_id === latestEnvId);
          let noData = false;

          if (latestEnvId === null) {
            selectedEnv = env[0];
            noData = true;
          }

          if (selectedEnv && selectedEnv.is_integrations === false) {
            noData = true;
          }

          if (selectedEnv) {
            this.setState({
              selectedEnvId: selectedEnv.env_id,
              selectedEnvName: selectedEnv.env_name,
              envList: env,
              noData:noData,
              loader: false
            });
          } else {
            this.setState({ noData: noData, loader: false });
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
        this.setState({ errorOccurred: true });
      }
    // }
  });
}

  callbackEnvironemnt(pmtest){
    this.setState({ 
      selectedEnvId: pmtest.value,
      selectedEnvName:pmtest.label});
  }

  render() {  
    
    const { location } = this.props;
    const { data } = location.state || {};
//     console.log(JSON.stringify(data));
// console.log("this.state.envList",this.state.envList);

    let {browserSessionId,browserTabId,selectedTab,selectedEnvId,selectedEnvName,teamId,userId} = this.state;
   if (data && Object.keys(data).length > 0) {
    if (data.env_id && !selectedEnvId) {
      selectedEnvId = Number(data.env_id);
    }
    if (data.type && selectedTab === "DQ") {
      selectedTab = data.type;
    }
  }

  const matchedEnv = Array.isArray(this.state.envList) && this.state.envList.find(env => env.env_id === selectedEnvId);
  if (matchedEnv && !this.state.selectedEnvName) {
    selectedEnvName = matchedEnv.env_name;
  }

  // Use state values directly to ensure props update when state changes
  selectedEnvId = this.state.selectedEnvId || selectedEnvId;
  selectedEnvName = this.state.selectedEnvName || selectedEnvName;

let featureAccess = getFeatureAccess()
let enableDQReportsTab = false;
if (!IS_NONE_CHECK.includes(featureAccess)) {
            const DQReportsTab = featureAccess["dq-reports"];
            enableDQReportsTab = DQReportsTab === true;
}


  return (
      <>
              <NavigationHeader
               selectedEnvId={selectedEnvId}
               selectedEnvName={selectedEnvName}
               envList={this.state.envList} 
               page="realtime"
               cachenable = {true}
               callbackEnvironemnt={this.callbackEnvironemnt}
              />
        <main>
        <div className="qd-rt_wrap rt-pipeline-wrap">
            {/* layout Menu */}
            <div className="qd-rt_menu">
              <ul className="qd-rt_menu-list">
                <li id = "lt_dq"className={this.state.selectedTab==="DQ" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="DQ" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Data Quality Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M1.71806 22.2819C2.19676 22.7606 2.77222 23 3.44444 23H20.5556C21.2278 23 21.8032 22.7606 22.2819 22.2819C22.7606 21.8032 23 21.2278 23 20.5556V3.44444C23 2.77222 22.7606 2.19676 22.2819 1.71806C21.8032 1.23935 21.2278 1 20.5556 1H3.44444C2.77222 1 2.19676 1.23935 1.71806 1.71806C1.23935 2.19676 1 2.77222 1 3.44444V20.5556C1 21.2278 1.23935 21.8032 1.71806 22.2819ZM17.9205 8.47042V7.24275C17.9205 6.16085 15.226 5.27846 11.9049 5.27846C8.58372 5.27846 5.88923 6.16085 5.88923 7.24275V8.47042C5.88923 9.55232 8.58372 10.4347 11.9049 10.4347C15.226 10.4347 17.9205 9.55232 17.9205 8.47042ZM17.9205 12.7673V10.005C16.628 10.8951 14.2626 11.3094 11.9049 11.3094C9.54716 11.3094 7.18165 10.8951 5.88923 10.005V12.7673C5.88923 13.8492 8.58372 14.7316 11.9049 14.7316C15.226 14.7316 17.9205 13.8492 17.9205 12.7673ZM17.9205 17.0642V14.3019C16.628 15.192 14.2626 15.6063 11.9049 15.6063C9.54716 15.6063 7.18165 15.192 5.88923 14.3019V17.0642C5.88923 18.1461 8.58372 19.0285 11.9049 19.0285C15.226 19.0285 17.9205 18.1461 17.9205 17.0642Z" fill="currentColor"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li>
                {/* <div className="menu-divider"></div>
                <li className={this.state.selectedTab==="MODEL" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="MODEL" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Data Model Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.08413 4.99304C4.83369 5.22783 4.47369 4.85217 4.72413 4.61739C5.90326 3.49044 7.33804 2.65565 8.91369 2.19652C9.24239 2.10261 9.38847 2.59826 9.05978 2.69739C7.5676 3.13043 6.20065 3.9287 5.08413 4.99304ZM2.36065 14.2957C2.43891 14.6296 1.93804 14.7496 1.85456 14.4209C1.46847 12.8296 1.46847 11.1757 1.85456 9.58435C1.93804 9.25043 2.43891 9.37565 2.36065 9.70957C2.00065 11.2017 1.99543 12.7983 2.36065 14.2957ZM9.05978 21.3026C9.38847 21.3965 9.24239 21.8974 8.91369 21.8035C7.33804 21.3443 5.90326 20.5096 4.72413 19.3826C4.47369 19.1478 4.83369 18.767 5.08413 19.007C6.20586 20.0765 7.56239 20.8643 9.05978 21.3026ZM18.472 19.0017C18.7172 18.767 19.0772 19.1426 18.832 19.3774C17.6528 20.5043 16.2233 21.3391 14.6424 21.7983C14.3137 21.8922 14.1676 21.3965 14.4963 21.2974C15.9885 20.8696 17.3554 20.0713 18.472 19.0017ZM21.1954 9.70435C21.1119 9.37044 21.618 9.25044 21.7015 9.57913C22.0876 11.1704 22.0876 12.8243 21.7015 14.4157C21.618 14.7496 21.1119 14.6243 21.1954 14.2904C21.5606 12.7983 21.5606 11.2017 21.1954 9.70435ZM14.4963 2.69739C14.1676 2.60348 14.3137 2.10261 14.6424 2.19652C16.218 2.65565 17.6528 3.49044 18.832 4.61739C19.0772 4.85217 18.7224 5.23304 18.472 4.99304C17.3502 3.92348 15.9989 3.13565 14.4963 2.69739ZM11.778 0C12.9102 0 13.8285 0.918261 13.8285 2.05043C13.8285 3.18261 12.9102 4.10087 11.778 4.10087C10.6459 4.10087 9.7276 3.18261 9.7276 2.05043C9.7276 0.918261 10.6459 0 11.778 0ZM22.1815 6.02087C22.7293 7.00174 22.3902 8.23304 21.4198 8.79652C20.4389 9.36522 19.1867 9.0313 18.6233 8.04522C18.3415 7.55478 18.2841 6.99652 18.4198 6.49044C18.712 5.4 19.8389 4.74783 20.9293 5.04C21.4302 5.17565 21.8737 5.49391 22.1606 5.97391C22.1659 5.99478 22.1763 6.00522 22.1815 6.02087ZM22.1711 18C21.6024 18.9809 20.3398 19.3148 19.3746 18.7461C18.3885 18.167 18.0598 16.9252 18.6233 15.9496C19.192 14.9687 20.4441 14.6348 21.4198 15.1983C22.4006 15.767 22.7346 17.0296 22.1711 18ZM11.778 24C10.6459 24 9.7276 23.0817 9.7276 21.9496C9.7276 20.8174 10.6459 19.8991 11.778 19.8991C12.9102 19.8991 13.8285 20.8174 13.8285 21.9496C13.8285 23.0817 12.9102 24 11.778 24ZM1.37456 17.9739C0.826735 16.9983 1.16587 15.7617 2.1363 15.1983C3.11717 14.6296 4.36934 14.9687 4.93804 15.9496C5.21978 16.44 5.27717 16.9983 5.14152 17.5043C4.84934 18.5948 3.72239 19.247 2.63195 18.9548C2.13108 18.8191 1.6876 18.5009 1.40065 18.0209C1.39021 18.0052 1.37978 17.9948 1.37456 17.9739ZM1.385 6C1.95369 5.01391 3.2163 4.68522 4.18152 5.2487C5.1676 5.82783 5.4963 7.06957 4.93282 8.04522C4.36934 9.0313 3.11717 9.36522 2.1363 8.79652C1.15543 8.22783 0.821518 6.97044 1.385 6Z" fill="#484848"/>
                          <path d="M11.2447 17.835L6.57799 15.42C6.36688 15.31 6.20299 15.165 6.08633 14.985C5.96966 14.805 5.91133 14.605 5.91133 14.385V9.615C5.91133 9.395 5.96966 9.195 6.08633 9.015C6.20299 8.835 6.36688 8.69 6.57799 8.58L11.2447 6.165C11.4558 6.055 11.678 6 11.9113 6C12.1447 6 12.3669 6.055 12.578 6.165L17.2447 8.58C17.4558 8.69 17.6197 8.835 17.7363 9.015C17.853 9.195 17.9113 9.395 17.9113 9.615V14.385C17.9113 14.605 17.853 14.805 17.7363 14.985C17.6197 15.165 17.4558 15.31 17.2447 15.42L12.578 17.835C12.3669 17.945 12.1447 18 11.9113 18C11.678 18 11.4558 17.945 11.2447 17.835ZM11.2447 12.345V16.455L11.9113 16.8L12.578 16.455V12.345L16.578 10.26V9.63L15.8613 9.255L11.9113 11.31L7.96133 9.255L7.24466 9.63V10.26L11.2447 12.345Z" fill="#484848"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li> */}
                {/* <div className="menu-divider"></div> */}
                <li className={this.state.selectedTab==="PIPELINE" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="PIPELINE" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Pipeline Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M9.6082 9.63242H11.4059V11.4182H6.81426C6.24596 11.4182 5.78259 11.8735 5.78259 12.4318V14.3657H4.0396C3.46536 14.3657 3 14.8249 3 15.3871V19.9786C3 20.5428 3.46731 21 4.0396 21H8.71094C9.28522 21 9.75037 20.5409 9.75235 19.9786V15.3871C9.75235 14.823 9.28504 14.3657 8.71275 14.3657H6.97069V12.5855H17.0299V14.3657H15.2872C14.7129 14.3657 14.2476 14.8249 14.2476 15.3871V19.9786C14.2476 20.5428 14.7149 21 15.2872 21H19.9603C20.5346 21 20.9999 20.5409 20.9999 19.9786V15.3871C20.9999 14.8229 20.5326 14.3657 19.9603 14.3657H18.2202V12.4318C18.2202 11.8735 17.7568 11.4182 17.1885 11.4182H12.594V9.63242H14.3921C14.9347 9.63242 15.3765 9.19854 15.3745 8.66547V3.96695C15.3745 3.43385 14.9329 3 14.3903 3H9.6082C9.0656 3 8.62403 3.43388 8.62403 3.96695V8.66547C8.62403 9.19857 9.06564 9.63242 9.6082 9.63242Z" fill="currentColor"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li>
            <li className={this.state.selectedTab==="MODEL" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="MODEL" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Data Model Performance</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 2C12.4724 2 12.9361 2.12611 13.3456 2.36402L13.3465 2.36314L19.6465 5.99982L19.65 6.00249C20.06 6.24163 20.401 6.58551 20.6379 6.99956C20.8747 7.41357 20.9995 7.88338 21 8.36154V15.6367C20.9995 16.1149 20.8747 16.5846 20.6379 16.9987C20.401 17.4127 20.06 17.7566 19.65 17.9957L19.6465 17.9984L13.3465 21.6351L13.3456 21.6342C12.9641 21.8558 12.5356 21.9788 12.0967 21.9947C12.0649 21.9981 12.0327 22 12 22C11.967 22 11.9345 21.9982 11.9024 21.9947C11.4636 21.9786 11.0349 21.8559 10.6535 21.6342V21.6351L4.35352 17.9984L4.35 17.9957C3.93999 17.7566 3.59904 17.4127 3.36211 16.9987C3.12526 16.5846 3.00049 16.1149 3 15.6367V8.36154L3.00615 8.18219C3.03368 7.76645 3.15497 7.3617 3.36211 6.99956C3.59903 6.58551 3.94003 6.24163 4.35 6.00249L4.35352 5.99982L10.6535 2.36314V2.36402C11.0632 2.12586 11.5273 2 12 2ZM4.8 15.6349L4.80791 15.7539C4.82341 15.8714 4.86134 15.9853 4.92041 16.0886C4.99869 16.2254 5.11142 16.3393 5.24648 16.4189L11.1 19.7972V12.5247L4.8 8.86762V15.6349ZM12.9 12.5247V19.7972L18.7535 16.4189C18.8886 16.3393 19.0013 16.2254 19.0796 16.0886C19.1583 15.951 19.1997 15.7947 19.2 15.6358V8.86762L12.9 12.5247ZM12 3.81834C11.842 3.81834 11.6868 3.86021 11.55 3.93998L11.5465 3.94176L5.72021 7.30409L12 10.9497L18.2789 7.30409L12.4535 3.94176L12.45 3.93998C12.3132 3.86021 12.158 3.81834 12 3.81834Z" fill="currentColor" />
                        </svg>
                      </div>
                  </RcTooltip>
                </li> 
 
      {
enableDQReportsTab &&  (
              <><div className="menu-divider"></div>
             <li className={this.state.selectedTab==="PIPELINE" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="PIPELINE" onClick={this.drxReport} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Month Report</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.80775 22C4.31058 22 3.885 21.823 3.531 21.469C3.177 21.115 3 20.6894 3 20.1923V4.80775C3 4.31058 3.177 3.885 3.531 3.531C3.885 3.177 4.31058 3 4.80775 3H9.25775C9.32058 2.44483 9.56292 1.97275 9.98475 1.58375C10.4064 1.19458 10.9131 1 11.5048 1C12.0964 1 12.6032 1.19458 13.025 1.58375C13.4468 1.97275 13.6859 2.44483 13.7423 3H18.1923C18.6894 3 19.115 3.177 19.469 3.531C19.823 3.885 20 4.31058 20 4.80775V20.1923C20 20.6894 19.823 21.115 19.469 21.469C19.115 21.823 18.6894 22 18.1923 22H4.80775ZM4.80775 20.5H18.1923C18.2693 20.5 18.3398 20.4679 18.4038 20.4038C18.4679 20.3398 18.5 20.2693 18.5 20.1923V4.80775C18.5 4.73075 18.4679 4.66025 18.4038 4.59625C18.3398 4.53208 18.2693 4.5 18.1923 4.5H4.80775C4.73075 4.5 4.66025 4.53208 4.59625 4.59625C4.53208 4.66025 4.5 4.73075 4.5 4.80775V20.1923C4.5 20.2693 4.53208 20.3398 4.59625 20.4038C4.66025 20.4679 4.73075 20.5 4.80775 20.5ZM7.5 18.1345H12.5C12.7125 18.1345 12.8906 18.0626 13.0343 17.9188C13.1781 17.7751 13.25 17.5969 13.25 17.3843C13.25 17.1718 13.1781 16.9937 13.0343 16.85C12.8906 16.7065 12.7125 16.6348 12.5 16.6348H7.5C7.2875 16.6348 7.10942 16.7066 6.96575 16.8503C6.82192 16.9941 6.75 17.1723 6.75 17.385C6.75 17.5975 6.82192 17.7756 6.96575 17.9193C7.10942 18.0628 7.2875 18.1345 7.5 18.1345ZM7.5 15.25H15.5C15.7125 15.25 15.8906 15.1781 16.0343 15.0343C16.1781 14.8904 16.25 14.7123 16.25 14.4998C16.25 14.2871 16.1781 14.109 16.0343 13.9655C15.8906 13.8218 15.7125 13.75 15.5 13.75H7.5C7.2875 13.75 7.10942 13.8219 6.96575 13.9658C6.82192 14.1096 6.75 14.2878 6.75 14.5003C6.75 14.7129 6.82192 14.891 6.96575 15.0345C7.10942 15.1782 7.2875 15.25 7.5 15.25ZM12.0375 3.63375C12.1792 3.49208 12.25 3.31292 12.25 3.09625C12.25 2.87958 12.1792 2.70042 12.0375 2.55875C11.8958 2.41708 11.7167 2.34625 11.5 2.34625C11.2833 2.34625 11.1042 2.41708 10.9625 2.55875C10.8208 2.70042 10.75 2.87958 10.75 3.09625C10.75 3.31292 10.8208 3.49208 10.9625 3.63375C11.1042 3.77542 11.2833 3.84625 11.5 3.84625C11.7167 3.84625 11.8958 3.77542 12.0375 3.63375Z" fill="#484848"/>
                        <path d="M11.0448 10.5847L10.1333 9.67317L8.45133 11.345C8.359 11.4483 8.24294 11.5 8.10317 11.5C7.9635 11.5 7.84533 11.4483 7.74867 11.345C7.64956 11.2527 7.6 11.1366 7.6 10.9968C7.6 10.8572 7.64956 10.739 7.74867 10.6423L9.7115 8.686C9.82094 8.56544 9.9605 8.50517 10.1302 8.50517C10.2998 8.50517 10.4415 8.56544 10.5552 8.686L11.4667 9.5975L13.2808 7.76033H12.5C12.3581 7.76033 12.2393 7.71245 12.1437 7.61667C12.0479 7.521 12 7.40222 12 7.26033C12 7.12278 12.0462 7.00506 12.1385 6.90717C12.2308 6.80928 12.3458 6.76033 12.4833 6.76033H14.3975C14.5649 6.76033 14.7072 6.81889 14.8243 6.936C14.9414 7.05311 15 7.19539 15 7.36283V9.26033C15 9.40222 14.9511 9.521 14.8532 9.61667C14.7553 9.71244 14.6376 9.76033 14.5 9.76033C14.3581 9.76033 14.2393 9.71417 14.1437 9.62183C14.0479 9.5295 14 9.41456 14 9.277V8.4795L11.8885 10.5847C11.7748 10.6983 11.6332 10.7552 11.4635 10.7552C11.2938 10.7552 11.1543 10.6983 11.0448 10.5847Z" fill="#484848"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li></>
            )
          }
     

                {/* <li className={this.state.selectedTab==="VERTICAL" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="VERTICAL" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Verticalization</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.96175 4.25H19.0388C19.2513 4.25 19.4293 4.32192 19.573 4.46575C19.7168 4.60958 19.7888 4.78775 19.7888 5.00025C19.7888 5.21292 19.7168 5.391 19.573 5.5345C19.4293 5.67817 19.2513 5.75 19.0388 5.75H4.96175C4.74925 5.75 4.57117 5.67808 4.4275 5.53425C4.28367 5.39042 4.21175 5.21225 4.21175 4.99975C4.21175 4.78708 4.28367 4.609 4.4275 4.4655C4.57117 4.32183 4.74925 4.25 4.96175 4.25ZM5.154 19.75C4.898 19.75 4.68334 19.6634 4.51 19.4902C4.33684 19.3169 4.25025 19.1022 4.25025 18.8462V13.75H3.94075C3.65609 13.75 3.42175 13.6388 3.23775 13.4163C3.05375 13.1939 2.99509 12.9404 3.06175 12.6558L4.06175 7.9635C4.10742 7.75533 4.21375 7.58442 4.38075 7.45075C4.54775 7.31692 4.73759 7.25 4.95025 7.25H19.0503C19.2629 7.25 19.4528 7.31692 19.6198 7.45075C19.7868 7.58442 19.8931 7.75533 19.9388 7.9635L20.9388 12.6558C21.0054 12.9404 20.9468 13.1939 20.7628 13.4163C20.5788 13.6388 20.3444 13.75 20.0598 13.75H19.7503V19C19.7503 19.2125 19.6783 19.3906 19.5345 19.5343C19.3907 19.6781 19.2125 19.75 19 19.75C18.7873 19.75 18.6093 19.6781 18.4658 19.5343C18.3221 19.3906 18.2503 19.2125 18.2503 19V13.75H13.7503V18.8462C13.7503 19.1022 13.6637 19.3169 13.4905 19.4902C13.3172 19.6634 13.1025 19.75 12.8465 19.75H5.154ZM5.75025 18.25H12.2503V13.75H5.75025V18.25Z" fill="currentColor"/>
                      </svg>

                      </div>
                  </RcTooltip>
                </li> */}
                {/* <div className="menu-divider"></div> */}
                {/* <li className={this.state.selectedTab==="ALERTS" ? "qd-rt_menu-item active": "qd-rt_menu-item"} data-name="ALERTS" onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Alerts</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.8802 12.6479V9.47922C12.8802 9.22983 12.7958 9.02078 12.6271 8.85208C12.4584 8.68337 12.2494 8.59902 12 8.59902C11.7506 8.59902 11.5416 8.68337 11.3729 8.85208C11.2042 9.02078 11.1198 9.22983 11.1198 9.47922V12.978C11.1198 13.0954 11.1418 13.209 11.1858 13.3191C11.2298 13.4291 11.2958 13.5281 11.3839 13.6161L13.8484 16.0807C14.0098 16.2421 14.2152 16.3227 14.4645 16.3227C14.7139 16.3227 14.9193 16.2421 15.0807 16.0807C15.2421 15.9193 15.3227 15.7139 15.3227 15.4645C15.3227 15.2152 15.2421 15.0098 15.0807 14.8484L12.8802 12.6479ZM12 20.9218C10.8998 20.9218 9.86919 20.7127 8.90831 20.2946C7.94743 19.8765 7.11125 19.3117 6.39976 18.6002C5.68826 17.8888 5.12347 17.0526 4.70538 16.0917C4.28729 15.1308 4.07824 14.1002 4.07824 13C4.07824 11.8998 4.28729 10.8692 4.70538 9.90831C5.12347 8.94743 5.68826 8.11125 6.39976 7.39976C7.11125 6.68826 7.94743 6.12347 8.90831 5.70538C9.86919 5.28729 10.8998 5.07824 12 5.07824C13.1002 5.07824 14.1308 5.28729 15.0917 5.70538C16.0526 6.12347 16.8888 6.68826 17.6002 7.39976C18.3117 8.11125 18.8765 8.94743 19.2946 9.90831C19.7127 10.8692 19.9218 11.8998 19.9218 13C19.9218 14.1002 19.7127 15.1308 19.2946 16.0917C18.8765 17.0526 18.3117 17.8888 17.6002 18.6002C16.8888 19.3117 16.0526 19.8765 15.0917 20.2946C14.1308 20.7127 13.1002 20.9218 12 20.9218ZM3.24205 7.98288C3.08068 7.82152 3 7.61614 3 7.36675C3 7.11736 3.08068 6.91198 3.24205 6.75061L5.75061 4.24205C5.91198 4.08068 6.11736 4 6.36675 4C6.61614 4 6.82152 4.08068 6.98288 4.24205C7.14425 4.40342 7.22494 4.6088 7.22494 4.85819C7.22494 5.10758 7.14425 5.31296 6.98288 5.47433L4.47433 7.98288C4.31296 8.14425 4.10758 8.22494 3.85819 8.22494C3.6088 8.22494 3.40342 8.14425 3.24205 7.98288ZM20.7579 7.98288C20.5966 8.14425 20.3912 8.22494 20.1418 8.22494C19.8924 8.22494 19.687 8.14425 19.5257 7.98288L17.0171 5.47433C16.8557 5.31296 16.7751 5.10758 16.7751 4.85819C16.7751 4.6088 16.8557 4.40342 17.0171 4.24205C17.1785 4.08068 17.3839 4 17.6333 4C17.8826 4 18.088 4.08068 18.2494 4.24205L20.7579 6.75061C20.9193 6.91198 21 7.11736 21 7.36675C21 7.61614 20.9193 7.82152 20.7579 7.98288ZM12 19.1614C13.7164 19.1614 15.1724 18.5636 16.368 17.368C17.5636 16.1724 18.1614 14.7164 18.1614 13C18.1614 11.2836 17.5636 9.82763 16.368 8.63203C15.1724 7.43643 13.7164 6.83863 12 6.83863C10.2836 6.83863 8.82763 7.43643 7.63203 8.63203C6.43643 9.82763 5.83863 11.2836 5.83863 13C5.83863 14.7164 6.43643 16.1724 7.63203 17.368C8.82763 18.5636 10.2836 19.1614 12 19.1614Z" fill="currentColor"/>
                        </svg>
                      </div>
                  </RcTooltip>
                </li>
                <li className={this.state.selectedTab==="NOTIFICATION" ? "qd-rt_menu-item active": "qd-rt_menu-item"} id="rt_menu_notification" data-name="NOTIFICATION"  onClick={this.handleTabSelection} // Call the handler on click
>
                  <RcTooltip 
                      placement="right" 
                      overlay={
                        <span>Notifications</span>
                      }
                      arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                  >
                      <div className="qd-rt_menu-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <g id="Group_5010" data-name="Group 5010" transform="translate(-87 -3903)">
                            <g id="bell_1_" data-name="bell (1)" transform="translate(88.82 3905)">
                              <path id="Path_1441" data-name="Path 1441" d="M17.545,14.911H2.816a.825.825,0,0,1-.8-.587.8.8,0,0,1,.338-.909,4.152,4.152,0,0,0,1.033-1.37A11.492,11.492,0,0,0,4.452,6.728a5.728,5.728,0,0,1,11.456,0,11.492,11.492,0,0,0,1.063,5.318A4.152,4.152,0,0,0,18,13.416a.8.8,0,0,1,.338.909A.825.825,0,0,1,17.545,14.911ZM4.574,13.275H15.786q-.093-.153-.187-.324a12.975,12.975,0,0,1-1.327-6.222,4.092,4.092,0,0,0-8.183,0,12.975,12.975,0,0,1-1.327,6.222Q4.668,13.122,4.574,13.275Z" fill="currentColor" />
                              <path id="Path_1442" data-name="Path 1442" d="M11.5,22.452A2.462,2.462,0,0,1,9.38,21.229a.818.818,0,0,1,1.416-.821.818.818,0,0,0,1.416,0,.818.818,0,0,1,1.416.821A2.462,2.462,0,0,1,11.5,22.452Z" transform="translate(-1.324 -3.452)" fill="currentColor" />
                            </g>
                            <g id="alarm_black_24dp" transform="translate(87 3903)">
                              <path id="Path_1426" data-name="Path 1426" d="M0,0H24V24H0Z" fill="none" />
                            </g>
                          </g>
                        </svg>
                        <span className="badge badge-alert">4</span>
                      </div>
                  </RcTooltip>
                </li> */}
              </ul>
            </div>
            {

              this.state.loader === true && (this.state.selectedTab !== "VERTICAL") 
              ?
                <div className="portlet w-100 h-100 d-flex align-items-center justify-content-center">
                  <div className="portlet-body">
                    <Load />
                  </div>
                </div>
              :

              (this.state.noData && this.state.selectedTab === "DQ" 
              ? 
                <>
                    <NoDataComponent
                        noContentSubtext={"Please Configure datasource to view Real-time"}
                        customButtonName={"Configure Datasource"}
                        navigatePage={"/configure"}
                        realtime = {true}
                        noDataFound = {this.state.noData}
                        selectedTab = {this.state.selectedTab}/>
                </>
              :     
              (this.state.noData && this.state.selectedTab === "PIPELINE"
                &&         
                <>
                    <NoDataComponent
                      noContentSubtext={"Please Configure pipeline to view Real-time"}
                      customButtonName={"Configure Pipeline"}
                      navigatePage={"/pipeline"}
                      realtime = {true}
                      noDataFound = {this.state.noData}
                      selectedTab = {this.state.selectedTab}/>
                </>
                )
              )  
            }

{this.state.selectedTab === "VERTICAL" ?  <LoadRealTimeCompoent 
              selectedTab={selectedTab}
              monitorModule = {this.props.monitorModuleProps}
              selectedEnvId={selectedEnvId}
              selectedEnvName={selectedEnvName}
              teamId={teamId}
              userId={userId}
              browserTabId={browserTabId}
              browserSessionId={browserSessionId}
            /> : this.state.noData === false && browserSessionId!==null && browserTabId!==null && selectedEnvId!==""  ? 
            <LoadRealTimeCompoent 
              selectedTab={selectedTab}
              selectedEnvId={selectedEnvId}
              selectedEnvName={selectedEnvName}
              teamId={teamId}
              userId={userId}
              browserTabId={browserTabId}
              browserSessionId={browserSessionId}
              data = {data}
              selectedDate={data?.date}
              integrationId = {data?.integration_id}
            /> : "" }
            <div className="rt-dropdown_backdrop"></div>
            <div className="qd-blur-loader: true"></div>  {/* Blur Loader - Add Show class */}
            {/* <AiAssistant /> */}
          </div>
        </main>


        {this.state.isDrxReportFullscreenMode ?
                            <DrxReportFullScreen fullScreenClassVal={this.state.DrxReportFullScreenClassKey}
                                                    title="Title"
                                                    key={"DrxReportFullScreen"}
                                                    closedrxReportfullscreen = {this.closedrxReportfullscreen}
                            >
                            </DrxReportFullScreen> : ''
                        }
      </>
    );
  }
}
